import { render, staticRenderFns } from "./wiadvanceDeal.vue?vue&type=template&id=40403220&lang=pug"
import script from "./wiadvanceDeal.vue?vue&type=script&lang=js"
export * from "./wiadvanceDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports